export default "__VITE_ASSET__C4yplHgJ__"